import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const UnstyledHeading = ({ level, ...props }) => {
  const H = `h${level || 2}`;
  return <H {...props} />;
};

UnstyledHeading.propTypes = {
  level: PropTypes.number,
};

const HeadingStyle = styled(UnstyledHeading).attrs(
  ({ $margin, $fontSize, $textAlign, $textTransform }) => ({
    $margin: $margin || "",
    $fontSize: $fontSize || undefined,
    $textAlign: $textAlign || "",
    $textTransform: $textTransform || "",
  })
)`
  ${({ $backgroundColor }) =>
    $backgroundColor &&
    css`
      background-color: ${$backgroundColor};
    `}
  ${({ $textColor }) =>
    $textColor &&
    css`
      color: ${$textColor};
    `}
${({ $linkColor }) =>
    $linkColor &&
    css`
      a {
        color: ${$linkColor};
      }
    `}
  margin: ${({ $margin }) => $margin};
  font-size: ${({ $fontSize }) => $fontSize};
  text-align: ${({ $textAlign }) => $textAlign};
  text-transform: ${({ $textTransform }) => $textTransform};
`;

const Heading = ({
  level,
  anchor,
  className,
  style,
  margin,
  fontSize,
  color,
  backgroundColor,
  linkColor,
  textAlign,
  textTransform,
  content,
}) => {
  return (
    <HeadingStyle
      level={level}
      {...(anchor ? { id: anchor } : {})}
      className={className}
      style={style}
      $margin={margin}
      $fontSize={fontSize}
      $textColor={color}
      $backgroundColor={backgroundColor}
      $linkColor={linkColor}
      $textAlign={textAlign}
      $textTransform={textTransform}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

Heading.propTypes = {
  anchor: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  margin: PropTypes.string,
  fontSize: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  linkColor: PropTypes.string,
  textAlign: PropTypes.string,
  textTransform: PropTypes.string,
  content: PropTypes.string,
  level: PropTypes.number,
};

export default Heading;
